$(document).ready(function(){

  
  if($(".main-list-collections").length){
    
    let options = {
        debug:true,
        loadingHtml: '<h2>Loading...</h2>',
        padding: 20,
        nextSelector: '.pagination:last a.pagination__item--prev:last',
        contentSelector: '.collections',
        pagingSelector:'.pagination',
        callback: ()=>{
          console.log("loaded")
          $('.jscroll-added .collection-list__item').detach().appendTo('.jscroll-inner > .collection-list')
          $('.jscroll-added').remove()
        }
    };
    
    $('.collections').jscroll(options);
  console.log("products collection")
  }else if($('.main-collection-product-grid').length){
    let options = {
        debug:true,
        loadingHtml: '<h2 class="lazyPaginationLoading">Loading...</h2>',
        padding: 20,
        nextSelector: '.pagination:last a.pagination__item--prev:last',
        contentSelector: '.collection',
        pagingSelector:'.pagination',
        callback: ()=>{
          console.log("loaded")
          $('.jscroll-added .grid__item').detach().appendTo('.jscroll-inner > .collection .product-grid')
          $('.jscroll-added').remove()
        }
    };
    
    $('.product-grid-container').jscroll(options);

    
    const targetNode = document.querySelector(".main-collection-product-grid");
    let c = null
    // Options for the observer (which mutations to observe)
    const config = { attributes: true, childList: true, subtree: true };
    
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
          console.log("A child node has been added or removed.");
        
          clearTimeout(c);
            c = setTimeout(function(){
             $('.lazyPaginationLoading').hide(100)
          },3000)
          
      }
    };
    
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
  }
  
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    scrollFunction(event,this)
  });
  let e = window.location
  if(e.hash != '')
    scrollFunction(event,e)
})

function scrollFunction(event,e){
  if (
      location.pathname.replace(/^\//, '') == e.pathname.replace(/^\//, '') 
      && 
      location.hostname == e.hostname
    ) {
      // Figure out element to scroll to
      var target = $(e.hash);
      target = target.length ? target : $('[name=' + e.hash.slice(1) + ']');
      // target = target.length ? target : $('#' + e.hash.slice(1));
      // Does a scroll target exist?
      if (target.length) {
        console.log("scrolling")
        // Only prevent default if animation is actually gonna happen
        if(event)
          event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 500, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
}
